import { userAccount } from "../../Account/AccountSlice";
import { useAppSelector } from "../../../../hooks";
import { useEffect, useState } from "react";
import { Modal, Spinner, Badge, ModalHeader, Button, ModalBody } from "reactstrap";
import { toTitleCase } from "../../../../Utility/toTitleCase";
import WelcomeTabContent from "./WelcomeTabContent";
import { getTodoCount } from "../../../SalesDep/To-Do List/TodoSelectors";
import { getWriterName } from "../../../SalesDep/Managers/SalesRepView/WriterSlice";
import { Clear } from "@mui/icons-material";

type Props = {
    visible: boolean;
    onClose: () => void;
};

const WelcomeModal = ({ visible, onClose }: Props) => {
    const account = useAppSelector(userAccount);
    const currentUser = useAppSelector(getWriterName);
    const taskValue = useAppSelector(getTodoCount);
    const notifications = useAppSelector((state) => state.notifications.pushNotifArr);
    const loading = useAppSelector(
        (state) => state.todo.loading || state.notifications.loading
    );
    const [activeTab, setActiveTab] = useState<number>(1);

    useEffect(() => {
        console.log('NOTIFs:', notifications);
    }, [notifications]);

    return (
        <Modal
            isOpen={visible}
            onClosed={onClose}
        >
            <ModalHeader
                className='bg-primary d-flex align-items-center'
                style={{ color: 'white', }}
            >
                <span 
                    style={{ color: 'white', fontWeight: 'bold', fontSize: 18, }}
                >
                    {
                        !currentUser 
                        ? `Welcome, ${toTitleCase(account?.name?.split(' ')[0])}!`
                        : `Welcome, ${toTitleCase(currentUser?.split(' ')[0])}!`
                    }
                </span>
                <Button 
                    title='Close'
                    onClick={onClose}
                    className="bg-transparent border-0 fw-bold text-white position-absolute end-0"
                    unmountOnClose
                >
                    <Clear />
                </Button>
            </ModalHeader>
            <ModalBody>
                <div 
                    style={{ flexDirection: 'row', marginLeft: 10, marginTop: 10 }}
                    className="d-flex align-items-center"
                >
                    <div
                        key={1}
                        style={{
                            flexDirection: 'row',
                            paddingRight: 10,
                            paddingInline: 5,
                            paddingBlock: 5,
                            borderTopRightRadius: 10,
                            borderTopLeftRadius: 10,
                            border: '2px solid #f1b434',
                            borderBottom: 'none',
                            cursor: 'pointer',
                        }}
                        className={activeTab === 1 ? `bg-primary` : `bg-white`}
                        onClick={() => setActiveTab(1)}
                    >
                        <span 
                            style={{ paddingInlineEnd: 5 }}
                        >
                            Tasks
                        </span>
                        <Badge 
                            pill
                            color={notifications?.length === 0 ? 'secondary' : 'danger'}
                        >
                            {
                                loading 
                                ? <Spinner color="white" style={{ width: '10px', height: '10px', }}/> 
                                : taskValue || 0
                            }
                        </Badge>
                    </div>
                    <div
                        key={2}
                        style={{
                            flexDirection: 'row',
                            paddingRight: 10,
                            paddingInline: 5,
                            paddingBlock: 5,
                            borderTopRightRadius: 10,
                            borderTopLeftRadius: 10,
                            border: '2px solid #f1b434',
                            borderBottom: 'none',
                            cursor: 'pointer',
                        }}
                        className={activeTab === 2 ? `bg-primary` : `bg-white`}
                        onClick={() => setActiveTab(2)}
                    >
                        <span 
                            style={{ paddingInlineEnd: 5 }}
                        >
                            Messages
                        </span>
                        <Badge 
                            pill
                            color={notifications?.length === 0 ? 'secondary' : 'danger'}
                        >
                            {
                                loading 
                                ? <Spinner color="white" style={{ width: '10px', height: '10px', }}/> 
                                : notifications?.length || 0
                            }
                        </Badge>
                    </div>
                </div>
                <div 
                    style={{
                        // flex: 1,
                        marginInline: 10,
                        marginBottom: 10,
                        padding: 5,
                        borderTopRightRadius: 10,
                        borderBottomRightRadius: 10,
                        borderBottomLeftRadius: 10,
                        borderColor: '#f1b434',
                        border: '2px solid #f1b434',
                        overflow: 'hidden',
                    }}
                >
                    {loading ? (
                        <div style={{ flex: 1, justifyContent: 'center'}}>
                            <Spinner size={"small"} color={"#f1b434"} />
                        </div>
                    ) : (
                        <WelcomeTabContent 
                            tab={activeTab}
                            todo={taskValue}
                            notifs={notifications}
                            onClose={onClose}
                        />
                    )
                    }
                </div>
            </ModalBody>
        </Modal>
    )
};

export default WelcomeModal;